import { IDropdownStyleProps, IDropdownStyles, IStyleFunctionOrObject } from "office-ui-fabric-react";

export const TaskDropDownStyles: IStyleFunctionOrObject<IDropdownStyleProps, IDropdownStyles> = {
    dropdown: {
        width: "100%"
    },
    title: {
        background: "transparent"
    }
};